import { DEBUG, ERROR, INFO, TRACE, WARN } from '../constants/LogLevels';
import { Payload } from '../types/payload';
import { log } from './loggers/log';
import { performanceObserverCallback } from './performance/performanceObserverCallback';

export function trace(message: string, payload: Payload = {}) {
  log(TRACE, message, payload);
}

export function debug(message: string, payload: Payload = {}) {
  log(DEBUG, message, payload);
}

export function info(message: string, payload: Payload = {}) {
  log(INFO, message, payload);
}

export function warn(message: string, payload: Payload = {}) {
  log(WARN, message, payload);
}

export function error(message: string, payload: Payload = {}) {
  log(ERROR, message, payload);
}

export const observePerformanceMetrics = (config: { types: string[] }) => {
  const isSupported = typeof window !== 'undefined' && 'PerformanceObserver' in window;

  if (isSupported) {
    const observer = new PerformanceObserver(performanceObserverCallback);

    config.types.forEach((type) => observer.observe({ type, buffered: true }));

    return observer;
  }
};
